import http from "../../../../../core/utils/apis/skillApi";

const TrainingReportsService = {
  getTrainingDetails: () => http.get("/trainings-reports/training-details"),
  getCompletionByMonth: (from, to) =>
    http.get(`/trainings-reports/completion-by-month?from=${from}&to=${to}`),
  getCompletionOverview: () =>
    http.get("/trainings-reports/completion-overview"),
  getUpcomingTrainings: () => http.get("/trainings-reports/upcoming-trainings"),
  getAverageDuration: () => http.get("/trainings-reports/average-duration"),
};

export default TrainingReportsService;
